<template>
  <input 
    type="hidden" 
    :id="'field-' + options.id" 
    :name="'fields[' + options.id + ']'"
    :value="options.preset_value" />
</template>

<script>
export default { 
  name: 'HiddenField',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$commit.setFieldValue({
      key: 'field-' + this.options.id, 
      value: this.options.preset_value
    })
  }
}
  
</script>
